export default __webpack_public_path__ + "static/Website_Beats_0-33cf217cd4f200edf8fc0b272ca51b05.mp3";